import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-colons',
  templateUrl: './colons.component.html',
  styleUrls: ['./colons.component.scss']
})
export class ColonsComponent implements OnInit {

  chambres = [
    {
      nom: 'batisse_1',
      colons: [
        // {nom: '', photos: ['img/...', 'img/..']}
        {nom: 'Baptiste'},
        {nom: 'Lino'},
        {nom: 'Tobias'},
        {nom: 'Antoine R'},
        {nom: 'Ambroise'}
      ]
    },
    {
      nom: 'batisse_2',
      colons: [
        {nom: 'Marion'},
        {nom: 'Janna'},
        {nom: 'Tahina'}
      ]
    },
    {
      nom: 'batisse_3',
      colons: [
        {nom: 'Elio'},
        {nom: 'Benjamin'},
        {nom: 'Sacha F'}
      ]
    },
    {
      nom: 'batisse_4',
      colons: [
        {nom: 'Timotei'},
        {nom: 'Arthur M'},
        {nom: 'Zephyr'},
        {nom: 'Paul'}
      ]
    },
    {
      nom: 'batisse_5',
      colons: [
        {nom: 'Etienne'},
        {nom: 'Adrien'},
        {nom: 'Antoine C'},
        {nom: 'Thaïs'},
        {nom: 'Robin'},
        {nom: 'Tristan'},
        {nom: 'Julien'}
      ]
    },
    {
      nom: 'epi_6',
      colons: [
        {nom: 'Emilie'},
        {nom: 'Mila'},
        {nom: 'Alicia'}
      ]
    },
    {
      nom: 'epi_7',
      colons: [
        {nom: 'Miya'},
        {nom: 'Anaïs'},
        {nom: 'Gaëlle'},
        {nom: 'Clara'}
      ]
    },
    {
      nom: 'epi_8',
      colons: [
        {nom: 'Armande'},
        {nom: 'Alysée'}
      ]
    },
    {
      nom: 'epi_9',
      colons: [
        {nom: 'Corto'},
        {nom: 'Rémi'},
        {nom: 'Thomas'},
        {nom: 'Valentin'},
        {nom: 'Maxime'},
        {nom: 'Naël'},
        {nom: 'Victor'}
      ]
    },
    {
      nom: 'epi_10',
      colons: [
        {nom: 'Arthur V'},
        {nom: 'Esaie'},
        {nom: 'Pierre L'},
        {nom: 'Pierre C'},
        {nom: 'Sascha'},
        {nom: 'Sacha S'},
        {nom: 'Clément'},
        {nom: 'Nestor'}
      ]
    }
  ];

constructor()
{
}

ngOnInit()
{
}

}
